export enum StorageStatus {
    PENDING = "PENDING",
    LOADING_TABLE = "LOADING_TABLE",
    PROCESSING = "PROCESSING",
    OK = "OK",
    ERROR = "ERROR",
    DELETED = "DELETED"
}
